// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"106":"project-workbench","176":"projects","818":"auth"}[chunkId] || chunkId) + "." + {"4":"32ba5e74","26":"a8d3728d","106":"5cafabc5","176":"5b231b67","381":"bbc163be","732":"f5519988","818":"36fda490","891":"acdc3d07"}[chunkId] + ".js";
};